import React from "react";

function SvgCalendar({ className }) {
  return (
    <svg
      className={`${className}`}
      width="10"
      height="15"
      viewBox="0 0 10 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.0001 14.4998C1.70767 14.4998 1.4151 14.4022 1.19224 14.2069C0.745815 13.8162 0.745815 13.1834 1.19224 12.7928L7.24296 7.49984L1.19296 2.20703C0.746529 1.81641 0.746529 1.18359 1.19296 0.792969C1.63939 0.402344 2.3626 0.402344 2.80903 0.792969L9.66617 6.79297C10.1126 7.18359 10.1126 7.81641 9.66617 8.20703L2.80903 14.207C2.58581 14.403 2.29296 14.4998 2.0001 14.4998Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgCalendar;
